// Parent panel
import { SFX } from '../core/audio';
import { t, LANGS, LANG_NAMES, getLang, setLang, onLangChange, DYNAMIC_KEYS, STRINGS, type Key, type Lang } from '../core/i18n';
import { $ } from './dom';
import { LEVELS, progOf } from './state';
import { I } from './icons';
import { Store } from '../core/store';
import { headImg, chOf, renderProfiles } from './profiles';
import { openMap } from './map';
import { openCredits } from './credits';

// Learning goals: all 'goal.<tag>' keys in src/lang/da.ts, in the order they appear there
const GOAL = DYNAMIC_KEYS[0];
const goalTags = Object.keys(STRINGS.da).filter(k => k.startsWith(GOAL)).map(k => k.slice(GOAL.length));

export function openParent() {
  const d = Store.d, card = $('#parentCard');
  const rows = d.profiles.map(p => {
    const st = Object.values(p.prog).reduce((a, v) => a + v.stars, 0), lv = Object.keys(p.prog).length, dk = Object.values(p.prog).filter(v => v.duck).length;
    return `<tr><td>${headImg(chOf(p), 40)}</td><td>${st} / ${LEVELS.length * 3}</td><td>${lv} / ${LEVELS.length}</td><td>${dk}</td><td><button class="pbtn warn" data-del="${p.id}">${t('parent.reset')}</button></td></tr>`;
  }).join('');
  const cur = Store.prof() || d.profiles[0];
  const learned = new Set<string>(); if (cur) LEVELS.forEach((L, i) => { if (progOf(cur, i)) L.learn.forEach(t => learned.add(t)); });
  const goals = goalTags.map(k => `<div><b class="${learned.has(k) ? 'ok' : ''}">✓</b><span>${t((GOAL + k) as Key)}</span></div>`).join('');
  const langs = LANGS.map(l => `<button class="pbtn${l === getLang() ? ' go' : ''}" data-language="${l}" lang="${l}">${LANG_NAMES[l]}</button>`).join(' ');
  card.innerHTML = `
    <div class="row" style="justify-content:space-between"><h2>${t('parent.title')}</h2><button class="rb" id="pClose" aria-label="${t('aria.close')}">${I.close}</button></div>
    <p>${t('parent.intro')}</p>
    <h3>${t('parent.progress')}</h3>
    ${d.profiles.length ? `<div style="overflow-x:auto"><table class="ptable"><tr><th>${t('parent.player')}</th><th>${t('parent.stars')}</th><th>${t('parent.levels')}</th><th>${t('parent.ducks')}</th><th></th></tr>${rows}</table></div>` : `<p>${t('parent.none')}</p>`}
    <h3>${t('parent.goalsTitle')} ${cur ? `${headImg(chOf(cur), 34)}` : ''}</h3>
    <p class="note">${t('parent.goalsNote')}</p>
    <div class="goals">${goals}</div>
    <h3>${t('parent.settings')}</h3>
    <label class="tog"><span>${t('parent.hintAlways')}<br><span class="note">${t('parent.hintAlwaysNote')}</span></span><input type="checkbox" id="setHint" ${d.settings.hintAlways ? 'checked' : ''}></label>
    <label class="tog"><span>${t('parent.sound')}</span><input type="checkbox" id="setSound" ${d.settings.sound ? 'checked' : ''}></label>
    <label class="tog"><span>${t('parent.music')}</span><input type="checkbox" id="setMusic" ${d.settings.music ? 'checked' : ''}></label>
    <div class="tog"><span>${t('parent.language')}</span><span>${langs}</span></div>
    <label class="tog"><span>${t('parent.testAll')}<br><span class="note">${t('parent.testAllNote')}</span></span><input type="checkbox" id="setTest" ${d.settings.testAll ? 'checked' : ''}></label>
    <div class="row" style="justify-content:flex-start"><button class="pbtn" id="creditsBtn">${t('parent.credits')}</button></div>
    <h3>${t('parent.buyTitle')}</h3>
    <p>${t('parent.buyText')}</p>
    <div class="row" style="justify-content:flex-start"><button class="pbtn go" id="buyBtn" ${d.unlocked ? 'disabled' : ''}>${d.unlocked ? t('parent.bought') : t('parent.buyBtn')}</button><span class="note">${t('parent.buyNote')}</span></div>
  `;
  $('#ovParent').hidden = false;
  $('#pClose').addEventListener('click', () => { $('#ovParent').hidden = true; if (!$('#scrMap').hidden) openMap(); else if (!$('#scrProfiles').hidden) renderProfiles(); });
  const checked = (e: Event) => (e.target as HTMLInputElement).checked;
  $('#setHint').addEventListener('change', e => { d.settings.hintAlways = checked(e); Store.save(); });
  $('#setSound').addEventListener('change', e => { d.settings.sound = checked(e); SFX.set('sound', checked(e)); Store.save(); });
  $('#setMusic').addEventListener('change', e => { d.settings.music = checked(e); SFX.init(); SFX.set('music', checked(e)); Store.save(); });
  $('#creditsBtn').addEventListener('click', () => { $('#ovParent').hidden = true; openCredits(); });
  $('#setTest').addEventListener('change', e => { d.settings.testAll = checked(e); Store.save(); });
  card.querySelectorAll<HTMLElement>('[data-language]').forEach(b => b.addEventListener('click', () => { SFX.play('click'); setLang(b.dataset.language as Lang); }));
  $('#buyBtn').addEventListener('click', () => { d.unlocked = true; Store.save(); SFX.play('win'); openParent(); });
  card.querySelectorAll<HTMLElement>('[data-del]').forEach(b => {
    let armed = false;
    b.addEventListener('click', () => {
      if (!armed) { armed = true; b.textContent = '✓ ?'; return; }
      d.profiles = d.profiles.filter(p => p.id !== b.dataset.del); if (d.cur === b.dataset.del) d.cur = null; Store.save(); openParent();
    });
  });
}
// Language changed in the panel: redraw the screen behind the panel, and the panel itself, in the new language
onLangChange(() => {
  if (!$('#scrMap').hidden) openMap(); else if (!$('#scrProfiles').hidden) renderProfiles();
  if (!$('#ovParent').hidden) openParent();
});
